import { LogGroup, Rect, Size } from "../.././MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { GenericSpriteCallback, OnSpriteCompleteCallback } from "./Sprite";

export enum SpriteUpdateState
{
	Idle,
	
	NoChange,
	FrameChanged,
	Finished,
}

export abstract class ISprite
{
	public abstract Running(): boolean;
	public abstract Reset(): void;
	public abstract Name(): string;
	public abstract Start(repeat: boolean): void;
	public abstract Stop(): void;
	public abstract StopAndReset(): void;
	public abstract Restart(repeat: boolean): void;
	public abstract ToLastFrame(): void;
	public abstract SetFPS(fps: number): void;
    public abstract GetFPS(): number;
	public abstract Update(millis: number | null): SpriteUpdateState;
	public abstract Repeat(repeat: boolean): void;
	public abstract GetDecodedFrame(frameIndex: number): ImageBitmap | HTMLCanvasElement;
	public abstract GetDecodedFrameRect(frameIndex: number): Rect;

	public abstract NumFrames(): number;
	//public abstract Repeat(): void;

	public abstract FrameChanged(): boolean;
	//public abstract CurrentFrameIndex(): number;

	public abstract Size(): Size;
	public abstract Copy(): ISprite;

	public abstract Decode(): void;
	public abstract Clean(): void;

	public abstract get IdleFrame(): ImageBitmap | HTMLCanvasElement;
	public abstract get IdleFrameRect(): Rect;
	public abstract get IdleFrameIndex(): number;

	public abstract get CurrentFrame(): ImageBitmap | HTMLCanvasElement;
	public abstract get CurrentFrameRect(): Rect;
	public abstract get CurrentFrameIndex(): number;

	public abstract get ResourceIdentifier(): ResourceIdentifier;
	public abstract get LogGroup(): LogGroup;

	
	public abstract get Duration(): number;

	public abstract ResetToFirstFrame: boolean;


	protected completeCallbacks: OnSpriteCompleteCallback[] = [];
	public ClearOnCompleteCallback():void
	{
		this.completeCallbacks = [];
	}

	protected OnSpriteComplete() 
	{
		for (let i = 0; i < this.completeCallbacks.length; i++) {
			this.completeCallbacks[i]();
		}
	}

	public AddOnCompleteCallback(callback: OnSpriteCompleteCallback): void 
	{
		this.completeCallbacks.push(callback);
	}



	
	protected decodedCallbacks: GenericSpriteCallback[] = [];

	public AddOnDecodedCallback(callback: GenericSpriteCallback): void
	{
		this.decodedCallbacks.push(callback);
	}

	protected decodedCallbacksSingleShot: GenericSpriteCallback[] = [];
	public AddOnDecodedCallbackSingleShot(callback: GenericSpriteCallback): void
	{
		this.decodedCallbacksSingleShot.push(callback);
	}

	protected FramesDecoded(): void
	{
		for (let i = 0; i < this.decodedCallbacksSingleShot.length; i++)
		{
			this.decodedCallbacksSingleShot[i]();
		}

		// clear single shot callbacks
		this.decodedCallbacksSingleShot = [];


		for (let i = 0; i < this.decodedCallbacks.length; i++)
		{
			this.decodedCallbacks[i]();
		}
	}



	protected decodeErrorCallbacks: GenericSpriteCallback[] = [];
	protected FramesDecodeError(): void
	{
		for (let i = 0; i < this.decodeErrorCallbacks.length; i++)
		{
			this.decodeErrorCallbacks[i]();
		}
	}

	public AddOnDecodeErrorCallback(callback: GenericSpriteCallback): void
	{
		this.decodeErrorCallbacks.push(callback);
	}




	protected cleanCallbacks: GenericSpriteCallback[] = [];
	protected FramesCleaned(): void
	{
		for (let i = 0; i < this.cleanCallbacks.length; i++)
		{
			this.cleanCallbacks[i]();
		}
	}

	public AddOnCleanedCallback(callback: GenericSpriteCallback): void
	{
		this.cleanCallbacks.push(callback);
	}

}